import WorkerDashboard from '../../Components/Forms/WorkerDashboard';

const Dashboard = () => {
  return (
    <div className="flex flex-col items-center bg-gray-100 min-h-screen">
            <WorkerDashboard />
    </div>
  );
};

export default Dashboard;
